module.exports = __webpack_public_path__ + "static/media/gray-call.08fb9de7.svg";